import { ActionCreatorWithPayload, createAction } from '@reduxjs/toolkit';

import {
  IncomingMessage,
  KioskOperationUpdate,
  KioskPaymentUpdate,
  QrCodeActionType,
  QrCodeLoginPayload,
  QrCodeTestFactoryPayload,
  SocketResponseUpdate,
} from 'modules/sockets/types/SocketResponse';

export const initialized = createAction('@SOCKET/INITIALIZED');

export const kioskSocketInitialized = createAction('@SOCKET/KIOSK/INITIALIZED');

export const creationFailure = createAction<string>('@SOCKET/INIT/FAILURE');

export const selfServiceUpdated = createAction<SocketResponseUpdate>('@SOCKET/RECEIVE_MESSAGE/SELF_SERVICE_UPDATED');

export const kioskPaymentUpdated = createAction<KioskPaymentUpdate>('@SOCKET/RECEIVE_MESSAGE/KIOSK_PAYMENT_UPDATED');

export const kioskOperationUpdated = createAction<KioskOperationUpdate>(
  '@SOCKET/RECEIVE_MESSAGE/KIOSK_OPERATION_UPDATED',
);

export const newIncomingMessage = createAction<IncomingMessage>(
  '@SOCKET/RECEIVE_MESSAGE/MESSAGE_SENT',
);

export const messageUpdateReaction = createAction<IncomingMessage>(
  '@SOCKET/RECEIVE_MESSAGE/MESSAGE_REACTION',
);

export const socketError = createAction<string | Event | undefined>('@SOCKET/ERROR');

export const sendMessage = createAction<Parameters<WebSocket['send']>[0]>('@SOCKET/SEND_MESSAGE');

export const qrCodeLogin = createAction<QrCodeLoginPayload>('@SOCKET/QR_CODE/LOGIN');
export const qrCodeTestFactory = createAction<QrCodeTestFactoryPayload>('@SOCKET/QR_CODE/TEST_FACTORY');

export const QR_CODE_ACTION_MAP: Record<QrCodeActionType, ActionCreatorWithPayload<any>> = {
  [QrCodeActionType.LOGIN]: qrCodeLogin,
  [QrCodeActionType.TEST_FACTORY]: qrCodeTestFactory,
};

export const isQrCodeActionType = (type: string): type is QrCodeActionType =>
  type in QR_CODE_ACTION_MAP;
